// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cffedc8c","239":"8be2d97d","455":"6673c915"}[chunkId] + ".chunk.js";
};